import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const registerGuest = async (id, data) => {
  const response = await axios.post(
    routes.inviteflowRegister(id),
    data,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default registerGuest;
